var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"consult-schedule-list-top"},[_c('div',{staticClass:"info"},[_c('h2',{staticClass:"desc"},[_vm._v("最新入驻")]),_c('h1',{staticClass:"title"},[_vm._v("壹心理咨询师新势力")])])])
}]

export { render, staticRenderFns }